const env = require("./config.js"); //配置文件，在这文件里配置你的OSS keyId和KeySecret,timeout:87600;

const base64 = require("./base64.js"); //Base64,hmac,sha1,crypto相关算法
require("./hmac.js");
require("./sha1.js");
const Crypto = require("./crypto.js");
import { Message } from "element-ui";
import axios from "../../axios";

/*
 *上传文件到阿里云oss
 *@param - filePath :图片的本地资源路径
 *@param - dir:表示要传到哪个目录下
 *@param - successc:成功回调
 *@param - failc:失败回调
 */
const uploadFile = function (filePath, dir, successc, failc) {
  console.log(filePath);
  if (!filePath || filePath.length < 9) {
    Message({
      message: "图片错误",
      type: "error",
    });
    return;
  }

  //图片名字 可以自行定义，     这里是采用当前的时间戳 + 150内的随机数来给图片命名的
  const aliyunFileKey =
    dir + new Date().getTime() + Math.floor(Math.random() * 150) + ".png";

  const aliyunServerURL = env.uploadImageUrl; //OSS地址，需要https
  const accessid = env.OSSAccessKeyId;
  const policyBase64 = getPolicyBase64();
  const signature = getSignature(policyBase64); //获取签名

  //请求数据
  var ossData = new FormData();
  ossData.append("name", filePath.name);
  // let filename = `${Date.parse(new Date())}` + file.name //图片名称
  ossData.append("key", aliyunFileKey);
  ossData.append("policy", policyBase64);
  ossData.append("OSSAccessKeyId", accessid);
  ossData.append("success_action_status", 200);
  ossData.append("signature", signature);
  ossData.append("file", filePath);

  axios.post(aliyunServerURL, ossData).then((res) => {
    if (res.status != 200) {
      failc(new Error("上传错误:" + JSON.stringify(res)));
      return;
    }
    successc(aliyunServerURL + aliyunFileKey);
    // this.imageUrl = dataUrl(res.data.Status);
    // this.imageUrl = this.imageUrl.filename;
    // this.Form.image = this.imageUrl;
    // this.loading = false;
  });

  // uni.uploadFile({
  //   url: aliyunServerURL, //开发者服务器 url
  //   filePath: filePath, //要上传文件资源的路径
  //   name: "file", //必须填file
  //   formData: {
  //     key: aliyunFileKey,
  //     policy: policyBase64,
  //     OSSAccessKeyId: accessid,
  //     signature: signature,
  //     success_action_status: "200",
  //   },
  //   success: function (res) {
  //     console.log(res);
  //     if (res.statusCode != 200) {
  //       failc(new Error("上传错误:" + JSON.stringify(res)));
  //       return;
  //     }
  //     successc(aliyunServerURL + aliyunFileKey);
  //   },
  //   fail: function (err) {
  //     err.wxaddinfo = aliyunServerURL;
  //     failc(err);
  //   },
  // });
};

const getPolicyBase64 = function () {
  let date = new Date();
  date.setHours(date.getHours() + env.timeout);
  let srcT = date.toISOString();
  const policyText = {
    expiration: srcT, //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
    conditions: [
      ["content-length-range", 0, 5 * 1024 * 1024], // 设置上传文件的大小限制,5mb
    ],
  };

  const policyBase64 = base64.encode(JSON.stringify(policyText));
  console.log(policyBase64);
  return policyBase64;
};

const getSignature = function (policyBase64) {
  const accesskey = env.AccessKeySecret;

  const bytes = Crypto.HMAC(Crypto.SHA1, policyBase64, accesskey, {
    asBytes: true,
  });
  const signature = Crypto.util.bytesToBase64(bytes);
  console.log(signature);
  return signature;
};

export default uploadFile;
